import React from "react";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";

//import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme

interface Props {
  traerCupones: Function;
  limpiarCupones: Function;
}
const HeaderShellFlota = (props: Props) => {
  return (
    <div className="p-panel-titlebar ">
      <div className="p-grid p-justify-between">
        <div className="p-col-2">Shell Flota </div>
        <div className="p-col-3">
          <Button
            className="p-button-rounded mr-2"
            label="Buscar"
            icon="pi pi-check"
            iconPos="left"
            onClick={() => props.traerCupones()}
          />
          <Button
            className="p-button-rounded p-button-warning"
            label="Limpiar"
            icon="pi pi-trash"
            iconPos="right"
            onClick={() => props.limpiarCupones()}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderShellFlota;
